<template>
  <div>

    <HeaderTop>
    </HeaderTop>
    <div id="shopcar">
      <div id="content">
        <div class="header">
          <img src="../image/logo.png" class="header_logo" />
          <span>客户下单</span>
        </div>
        <div class="cont_title">
          <span>订单查询</span>
        </div>
      </div>
    </div>
  </div>



</template>

<script scoped>
export default {
  data(){
    return{

    }
  },
  methods:{

  }
}
</script>

<style scoped>

#content>.header{
  width: 100%;
  height: 90px;
  margin-top: 10px;
  position: relative;
  margin-left: 10%;
  display: flex;
}
.header>img{
  width: 80px;
  height: 80px;
  /*border: 1px solid gray;*/
  /*border-radius: 50%;*/
  cursor: pointer;
}
.header>span{
  display: inline-block;
  font-size: 25px;
  height: 35px;
  font-weight: 700;
  position: absolute;
  top: 30%;
  margin-left: 100px;
  cursor: pointer;
}
#content>.cont_title{
  margin: 10px auto;
  width: 80%;
  height: 35px;
  border-bottom: 2px solid #e6e6e6;
}
.cont_title>span{
  display: inline-block;
  font-weight: 700;
  font-size: 17px;
  height: 100%;
  width: 100px;
  text-align: center;
  line-height: 25px;
  cursor: pointer;
  color: #f40;
  border-bottom: 2px solid #f40;
  display: flex;
}

</style>



// WEBPACK FOOTER //
// src/components/order/clientOrdersQuery.vue